<style scoped>
  .new_context {
    padding: 0 0.15rem 0.8rem;
    /* padding: 0 0.15rem 1.5rem; */
    /* transform: none; */
  }

  .new_context_bot {
    padding: 0 0.15rem 1.5rem;
  }

  .context_title {
    display: flex;
    align-items: center;
    margin: 0.1rem 0;
  }

  .context_title img {
    width: 1.1rem;
    height: 0.2rem;
  }

  .context_title span {
    color: #333333;
    margin-left: 0.08rem;
    font-size: 0.16rem;
    font-weight: bold;
  }

  .to_use {
    width: 100%;
    height: 0.86rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.06rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.1rem;
    margin: 0.15rem 0;
  }

  .use_left {
    display: flex;
  }

  .use_tips {
    margin-left: 0.1rem;
    color: #999999;
    font-size: 0.14rem;
  }

  .user_tips_top {
    color: #333333;
    font-weight: bold;
  }

  .use_left img {
    width: 0.36rem;
    height: 0.36rem;
  }

  .use_btn {
    width: 0.64rem;
    height: 0.3rem;
    text-align: center;
    line-height: 0.3rem;
    background: linear-gradient(
            135deg,
            rgba(255, 172, 85, 1) 0%,
            rgba(255, 57, 31, 1) 100%
    );
    box-shadow: 0px 0.04rem 0.1rem 0px rgba(255, 191, 128, 0.2);
    border-radius: 0.15rem;
    color: #fff;
    font-size: 0.14rem;
  }

  .vip_product {
    margin-top: 0.25rem;
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: space-between;
  }

  .pro_tips {
    width: 1.67rem;
    height: 1.85rem;
    background: linear-gradient(
            180deg,
            rgba(255, 253, 250, 1) 0%,
            rgba(255, 242, 228, 1) 100%
    );
    box-shadow: 0 0 0.08rem 0 rgba(255, 255, 255, 0.5);
    border-radius: 0.06rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .pro_tips img {
    position: absolute;
    left: 0.47rem;
    width: 0.73rem;
    height: 0.18rem;
    top: -0.09rem;
  }

  .tips_txt {
    margin-top: 0.2rem;
    font-size: 0.16rem;
    font-weight: bold;
    color: #333333;
  }

  .tips_money {
    color: #ff514a;
    font-size: 0.2rem;
    font-weight: bold;
    font-family: DINAlternate-Bold;
    margin-top: 0.05rem;
  }

  .tips_time {
    font-size: 0.18rem;
    color: #333333;
    font-weight: bold;
    margin-top: 0.05rem;
  }

  .tips_user {
    color: #999999;
    font-size: 0.12rem;
    margin-top: 0.05rem;
  }

  .tips_btn {
    width: 0.64rem;
    height: 0.3rem;
    border-radius: 0.15rem;
    border: 0.01rem solid rgba(255, 81, 74, 1);
    color: #ff514a;
    font-size: 0.14rem;
    margin-top: 0.1rem;
    text-align: center;
    line-height: 0.3rem;
  }

  .download {
    width: 100%;
    height: 2.84rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.06rem;
    padding: 0 0.1rem;
    margin-bottom: 0.25rem;
  }

  .download_tips {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.25rem;
  }

  .tips_left {
    margin-left: 0.1rem;
  }

  .line_through {
    text-decoration: line-through;
  }

  .down_tips {
    width: 100%;
    height: 1.5rem;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.08);
    border-radius: 0.06rem;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    margin-top: 0.15rem;
  }

  .down_top {
    margin-left: 0.1rem;
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
  }

  .down_top span {
    width: 2.15rem;
    margin-left: 0.1rem;
    color: #333333;
    font-size: 0.14rem;
  }

  .down_top img {
    width: 0.96rem;
    height: 0.6rem;
  }

  .join_now {
    width: 90%;
    height: 0.5rem;
    background: linear-gradient(180deg, #6B6A90 0%, #3F3D65 57%, #3F3D65 100%);
    border-radius: 0.39rem;
    font-weight: bold;
    font-size: 0.17rem;
    text-align: center;
    line-height: 0.5rem;
    color: #FFFFFF;
    /* margin-top: 0.35rem; */
    position: fixed;
    bottom: 0.15rem;
    /* bottom: 0.85rem; */
    left: 5%;
    /* -webkit-transform: translateZ(0); */
    display: flex;
    justify-content: center;
  }

  .join_now_bot {
    bottom: 0.85rem;
  }

  /* 弹框 */
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .task_img {
    width: 2.55rem;
    height: auto;
  }

  .task_close_img {
    width: 0.3rem;
    height: auto;
    margin-top: 0.4rem;
  }

  .task {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  >>> .van-overlay {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .con_con {
    font-size: 0.2rem;
  }

  .to_use .benefit_gift_title {
    width: 1.28rem;
    font-size: 0.16rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin: 20px 0px 13px 0px;
  }

  .to_use .benefit_gift_img {
    width: 1.36rem;
    margin-bottom: 0.2rem;
  }

  .to_use .lock {
    width: 0.8rem;
    height: 0.3rem;
    border-radius: 0.15rem;
    opacity: 0.3;
    border: 1px solid #E0E0E0;
    font-size: 0.12rem;
    line-height: 0.3rem;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333;
  }

  .desc{
    font-size: 0.11rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFF0E1;
  }

  .noVip .head_bg .card{
    border: 1px solid #1F1F36;
  }
  .noVip .head_bg .card .img{
    width: 90%;
    margin: 0.2rem auto;
  }
  .noVip .head_bg .icons{
    display: flex;
    justify-content: space-around;
  }
  .noVip .head_bg .icons .img{
    width: 0.25rem;
    height: 0.25rem;
    margin-bottom: 0.1rem;
  }

</style>
<template>
  <div class="handlevip_box" v-if="pageShow">
    <div class="isVip"
         v-if="vipInfo.hasMember == '1'">
      <div class="myvip_box">
        <div class="vip_img">
          <div class="con_box">
            <img class="portrait"
                 src="../../assets/img/vip/my_head.png"
                 alt=""/>
            <div class="con">
              <ul>
                <li class="fn16">{{ vipInfo.memberType }}会员</li>
                <li class="fn14">
                  有效期至：{{
                  vipInfo.endTime ? vipInfo.endTime.slice(0, 10) : ""
                  }}
                </li>
              </ul>
            </div>
            <!-- 续费功能 -->
            <div class="check_box"
                 v-if="vipInfo.renewal == '1'">
              <span class="check_btn"
                    @click="toShow()">续费</span>
            </div>
          </div>
        </div>
        <!--<div class="my_equity">
          <div class="banner_box"
               :class="{
              banner_box1:
                vipInfo.memberTypeId == 3 || vipInfo.memberTypeId == 4,
            }">
            <div class="title_box">
              <div class="box">
                <p class="acc_type">{{ vipInfo.memberType }}会员</p>
              </div>
            </div>
            <div class="equity_item">
              <div class="item"
                   v-for="(item, index) in vipList"
                   :key="index">
                <span :class="'my_icon' + index"></span><br />
                <p class="equity_num">
                  <span :class="{
                      purple:
                        vipInfo.memberTypeId == 3 || vipInfo.memberTypeId == 4,
                    }">{{ item.rate }}</span>
                </p>
                <p>{{ item.vipType }}</p>
              </div>
            </div>
          </div>
          <div class="check_list">
            <ul>
              <li>
                <span class="vipNot_icon7_1"></span>
                <div class="right"
                     @click="toCheck('h5_vip_center_button_click', '黑名单检测')">
                  <p class="cl_title">黑名单检测</p>
                  <p>
                    专业版{{ vipInfo.profession }}次 普通版{{
                      vipInfo.ordinary
                    }}次
                    <span class="triangle_border_right"></span>
                  </p>
                </div>
              </li>
              <li>
                <span class="vipNot_icon10"></span>
                <div class="right"
                     @click="toPage1('h5_vip_center_button_click', '我的卡券')">
                  <p class="cl_title">拒就赔现金券</p>
                  <p>
                    贷款被拒后可提现 <span class="triangle_border_right"></span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>-->

        <div class="my_equity">
          <div class="banner_box_new"
               :class="{
              banner_box1_new:
                vipInfo.memberTypeId == 3 || vipInfo.memberTypeId == 4,
            }" @click="toPageUrl(vipChoseListOne.pageUrl)">
            <!--<div class="title_box">
              <div class="box">
                <p class="acc_type">{{ vipInfo.memberType }}会员</p>
              </div>
            </div>
            <div class="equity_item">
              <div class="item"
                   v-for="(item, index) in vipList"
                   :key="index">
                <span :class="'my_icon' + index"></span><br />
                <p class="equity_num">
                  <span :class="{
                      purple:
                        vipInfo.memberTypeId == 3 || vipInfo.memberTypeId == 4,
                    }">{{ item.rate }}</span>
                </p>
                <p>{{ item.vipType }}</p>
              </div>
            </div>-->

            <img src="../../assets/img/vip/myVip_bg_new.png" style="width: 100%;height: auto;">
            <div class="center">
              <div class="product">
                <div class="product_name">{{vipChoseListOne.name}}</div>
                <span class="ed">{{vipChoseListOne.limit}}</span>
              </div>
            </div>

          </div>


          <a href="https://wj.qq.com/s2/9486885/602b">
            <div style="width: 100%;">
              <img src="../../assets/img/vip/myVip_kefu_new.png" class="kefu_tip">
            </div>
          </a>
        </div>

        <!--<div class="line_bg"></div>-->
        <div class="vip_list">
          <h3 class="title mb0"><span class="line"></span>会员权益</h3>
          <ul>
            <li class="qy_li">
              <span><img src="../../assets/img/vip/myVip_qy_01_new.png" class="qy_img"></span>
              <div class="qy_center">
                <p class="qy_center_title">拒就赔红包</p>
                <span class="qy_center_content">指定产品被拒绝即可操作提现</span>
              </div>
              <div class="qy_go_scan" @click="toPage1('h5_vip_center_button_click', '我的卡券')">去查看</div>
            </li>
            <div class="clear"></div>


            <li class="qy_li">
              <span><img src="../../assets/img/vip/myVip_qy_02_new.png" class="qy_img"></span>
              <div class="qy_center">
                <p class="qy_center_title">优惠券礼包</p>
                <span class="qy_center_content">视频影音权益大礼包</span>
              </div>
              <div class="qy_go_scan" @click="toPage1('h5_vip_center_button_click', '我的卡券')">去查看</div>
            </li>
            <div class="clear"></div>


            <li class="qy_li">
              <span><img src="../../assets/img/vip/myVip_qy_03_new.png" class="qy_img"></span>
              <div class="qy_center">
                <p class="qy_center_title">黑名单检测</p>
                <span class="qy_center_content">会员免费检测风险</span>
              </div>
              <div class="qy_go_scan" @click="toCheck('h5_vip_center_button_click', '黑名单检测')">去查看</div>

            </li>
            <div class="clear"></div>

            <li class="qy_li">
              <span><img src="../../assets/img/vip/myVip_qy_04_new.png" class="qy_img"></span>
              <div class="qy_center">
                <p class="qy_center_title">专属客服</p>
                <span class="qy_center_content">专业售后服务</span>
              </div>
              <a href="http://thread.tcjhz.com/agree/helpCenter">
                <div class="qy_go_scan">去联系</div>
              </a>
            </li>
            <div class="clear"></div>

            <li class="qy_li">
              <span><img src="../../assets/img/vip/myVip_qy_05_new.png" class="qy_img"></span>
              <div class="qy_center">
                <p class="qy_center_title">加速审核</p>
                <span class="qy_center_content"
                      style="font-size: 11px;">审核中的订单已开通加速<br> 最高提速50% 24小时内出结果</span>
              </div>
            </li>
            <div class="clear"></div>
          </ul>
          <!--<ul class="list_box"
              v-if="vipChoseList.length > 0">
            <a style="display:block;"
               v-for="(item, index) in vipChoseList"
               :key="index"
               href="javascript:void(0)"
               @click="toDetail(item)">
              <li :class="{ mgl: index % 2 != 0 }">
                <img class="portrait"
                     :src="item.icon"
                     alt="" />
                <div class="list_con">
                  <ul>
                    <li class="name">{{ item.name }}</li>
                    <li class="money">
                      <span class="mo">{{ item.limit }}</span>
                    </li>
                  </ul>
                </div>
              </li>
            </a>
          </ul>-->


        </div>
        <!--<div class="vip_list">
          <h3 class="title mb0"><span class="line"></span>会员专属投诉通道</h3>
          <a href="https://wj.qq.com/s2/9485033/805c" style="text-decoration: none;display: block;width: 100%"><button class="btn">我要投诉</button></a>
        </div>-->
        <a href="https://thread.tcjhz.com/agree/helpCenter">
          <div class="bottom_kefu">我有问题?<span style="color: #FF8E2F;">联系客服</span></div>
        </a>
      </div>
    </div>
    <div class="noVip"
         v-if="vipInfo.hasMember == '0'">
      <div class="head_bg">
        <div class="card">
          <div class="img">
            <img src="@/assets/img/vip/member_info_card.png" style="width: 100%;height: 100%;"/>
          </div>
        </div>
        <div class="icons">
          <div>
            <div class="img" style="margin-left: 10px;"><img src="@/assets/img/vip/notVip_card_icon1.png" style="width: 100%;height: 100%;"/></div>
            <div class="desc">加速审核</div>
          </div>
          <div>
            <div class="img" style="margin-left: 5px;"><img src="@/assets/img/vip/notVip_card_icon2.png" style="width: 100%;height: 100%;"/></div>
            <div class="desc">拒就赔</div>
          </div>
          <div>
            <div class="img" style="margin-left: 15px;"><img src="@/assets/img/vip/notVip_card_icon3.png" style="width: 100%;height: 100%;"/></div>
            <div class="desc">黑名单检测</div>
          </div>
          <div>
            <div class="img" style="margin-left: 10px;"><img src="@/assets/img/vip/notVip_card_icon4.png" style="width: 100%;height: 100%;"/></div>
            <div class="desc">专属客服</div>
          </div>
          <div>
            <div class="img" style="margin-left: 10px;"><img src="@/assets/img/vip/notVip_card_icon5.png" style="width: 100%;height: 100%;"/></div>
            <div class="desc">生活权益</div>
          </div>
        </div>

      </div>
      <!--<div class="aaa"
           @click="toShow('h5_vip_center_join_click')">


          <div class="con">
              <p class="con_title">
                  <span class="title_left"></span><span class="con_con">VIP尊享8大特权</span><span
                      class="title_right"></span>
              </p>
              <div class="ban_box">
                  <div class="item">
                      <span class="icon1_1"></span>
                      <span class="notVip_icon1"></span><br/>
                      <p>征信检测</p>
                  </div>
                  <div class="item">
                      <span class="notVip_icon7"></span>
                      <p>拒就赔保障</p>
                  </div>
                  <div class="item">
                      <span class="icon3_1"></span>
                      <span class="notVip_icon8"></span>
                      <p>优先审核</p>
                  </div>
                  <div class="item">
                      <span class="notVip_icon2"></span>
                      <p>免费匹配</p>
                  </div>
              </div>
              <div class="ban_box mt">
                  <div class="item">
                      <span class="notVip_icon5"></span>
                      <p>专属客服</p>
                  </div>
                  <div class="item">
                      <span class="notVip_icon3"></span>
                      <p>会员专属产品</p>
                  </div>
                  <div class="item">
                      <span class="notVip_icon6"></span>
                      <p>下款秘籍</p>
                  </div>
                  <div class="item">
                      <span class="notVip_icon9"></span>
                      <p>优惠券礼包</p>
                  </div>
              </div>

              &lt;!&ndash; <div class="buy_btn"
                   @click="toShow('h5_vip_center_join_click')">即刻加入</div> &ndash;&gt;
          </div>

          &lt;!&ndash; <div
            class="limit_bg"
            v-if="memberInfoList[0]"
            @click="toShow('h5_vip_center_recommend_click')"
          >
            <p class="limit_item">
              <span class="special_price"
                >{{ memberInfoList[0].vipOption }}限时特价</span
              >
              <span class="money">
                <span class="mo">￥{{ memberInfoList[0].price }}</span></span
              >
            </p>
            <p class="limit_item">
              <span class="rush_buy"
                >已有{{ memberInfoList[0].memberCount }}人购买</span
              >
              <span class="original_money"
                >原价<span class="undeline"
                  >￥{{ memberInfoList[0].originalPrice }}</span
                ></span
              >
            </p>
          </div> &ndash;&gt;
      </div>-->
      <!-- ---- -->
      <div class="new_context"
           :class="{ new_context_bot: paddingBottom }"
           @click="toShow('h5_vip_center_join_click')" style="margin-top: -0.5rem;">
        <div class="context_title">
          <img src="@/assets/img/vip/vip_title1.png"
               alt=""/>
        </div>
        <div style="width: 100%;">
          <img src="@/assets/img/vip/privilege_1_img1.png" style="width: 100%;height: 100%;"/>

        </div>
        <!--<div class="to_use">
            <div class="use_left">
                <img src="@/assets/img/vip/details_icon_1.png"
                     alt=""/>
                <div class="use_tips">
                    <p class="user_tips_top">拒就赔</p>
                    <p>最高可赔100元(限指定产品)</p>
                </div>
            </div>
            <div class="use_btn">去使用</div>
        </div>-->
        <div class="context_title">
          <img src="@/assets/img/vip/vip_title2.png"
               alt=""/>
        </div>
        <div>
          <img src="@/assets/img/vip/privilege_2_img1.png" style="width: 100%;margin-bottom: 0.05rem;"/>
          <img src="@/assets/img/vip/privilege_2_img2.png" style="width: 100%;margin-bottom: 0.05rem;"/>
          <img src="@/assets/img/vip/privilege_2_img3.png" style="width: 100%;"/>
        </div>
        <!--<div class="to_use" style="height: 100%;">
            <div class="use_left">
                <div class="use_tips">
                    <p class="benefit_gift_title">会员超值权益礼包</p>
                    <p class="benefit_gift_img"><img src="@/assets/img/vip/benefit_gift.png"
                                                     style="width: 100%;height: 100%;"
                                                     alt=""/></p>
                </div>
            </div>
            <div class="lock"><img src="@/assets/img/vip/lock.png"
                                   style="width: 0.12rem;height: 0.12rem;margin-right: 0.05rem;" alt=""/>待解锁
            </div>
        </div>-->
        <!--<div class="vip_product">
          <div class="pro_tips">
            <img src="@/assets/img/vip/img_vip_product.png"
                 alt="" />
            <span class="tips_txt">极速信用卡贷</span>
            <span class="tips_money">3000～2万</span>
            <span class="tips_time">3-12月</span>
            <span class="tips_user">低门槛 有身份证即可贷</span>
            <div class="tips_btn">去解锁</div>
          </div>
          <div class="pro_tips">
            <img src="@/assets/img/vip/img_vip_product.png"
                 alt="" />
            <span class="tips_txt">低息消费贷</span>
            <span class="tips_money">5000～20万</span>
            <span class="tips_time">6-24月</span>
            <span class="tips_user">在线审核 通过率高达98%</span>
            <div class="tips_btn">去解锁</div>
          </div>
        </div>-->
        <div class="context_title">
          <img src="@/assets/img/vip/vip_title3.png"
               alt=""/>
        </div>
        <div>
          <img src="@/assets/img/vip/privilege_3_img1.png" style="width: 100%;height: 100%;"/>
        </div>
        <!--<div class="download">
            <div class="download_tips">
                <div class="use_left">
                    <img src="@/assets/img/vip/details_icon_2.png"
                         alt=""/>
                    <div class="use_tips">
                        <p class="user_tips_top">黑名单检测</p>
                        <p>
                            <span>会员免费</span>
                            <span class="tips_left line_through">原价¥19.90元</span>
                        </p>
                    </div>
                </div>
                &lt;!&ndash;<div class="use_btn">去检测</div>&ndash;&gt;
            </div>

            <div class="download_tips">
                <div class="use_left">
                    <img src="@/assets/img/vip/details_icon_3.png"
                         alt=""/>
                    <div class="use_tips">
                        <p class="user_tips_top">专属客服</p>
                        <p>
                            <span>会员专属客服</span>
                            &lt;!&ndash;<span class="tips_left line_through">原价¥19.90元</span>&ndash;&gt;
                        </p>
                    </div>
                </div>
                &lt;!&ndash;<div class="use_btn">去检测</div>&ndash;&gt;
            </div>

            <div class="download_tips">
                <div class="use_left">
                    <img src="@/assets/img/vip/details_icon_4.png"
                         alt=""/>
                    <div class="use_tips">
                        <p class="user_tips_top">优先审核</p>
                        <p>
                            <span>独享优先审核通道 最高提速50%</span>
                        </p>
                    </div>
                </div>
                &lt;!&ndash;<div class="use_btn">去检测</div>&ndash;&gt;
            </div>

            <div class="download_tips">
                <div class="use_left">
                    <img src="@/assets/img/vip/details_icon_5.png"
                         alt=""/>
                    <div class="use_tips">
                        <p class="user_tips_top">免费匹配</p>
                        <p>
                            <span>优质名额 匹配符合的机构</span>
                        </p>
                    </div>
                </div>
                &lt;!&ndash;<div class="use_btn">去检测</div>&ndash;&gt;
            </div>
        </div>-->
        <!--<div class="context_title">
            <img src="@/assets/img/vip/vip_title4.png"
                 alt=""/>
            <span>下款秘籍</span>
        </div>
        <div class="down_tips">
            <div class="down_top">
                <img src="@/assets/img/vip/down_load1.png"
                     alt=""/>
                <span>网贷太频繁！怎么样才能贷到款？ </span>
            </div>
            <div class="down_top">
                <img src="@/assets/img/vip/down_load2.png"
                     alt=""/>
                <span>是什么在慢慢偷走你的信用额度? </span>
            </div>
        </div>-->
        <div class="join_now"
             :class="{ join_now_bot: paddingBottom }"
             @click="toShow('h5_vip_center_join_click')">
          <span style="position: absolute;">即刻加入</span>
        </div>
      </div>
      <!-- ---- -->
    </div>
    <PayToast :isShow="isShow"
              :isColor="isColor"
              :scenceCode="scenceCode"
              :noJson="noJson"
              :productId="productId"
              :orderId="orderId"
              :buyEntrance="buyEntrance"
              :eventKey="eventKey"></PayToast>
    <van-overlay :show="show"
                 @click="show = false">
      <div class="wrapper">
        <!-- <div class="block"
             @click.stop /> -->
        <div class="task">
          <img @click.stop="tomember"
               class="task_img"
               src="@/assets/img/vip/img_tc_2.png"
               alt=""/>
          <img @click.stop="toHide"
               class="task_close_img"
               src="@/assets/img/vip/icon_close.png"
               alt=""/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import {Toast} from "vant";
  import PayToast from "@/components/payToast";

  export default {
    components: {
      // Head,
      PayToast,
    },
    data() {
      return {
        eventKey: "h5_vip_center_submit_click",
        appVersion: localStorage.getItem("appVersion"),
        productId: 0,
        orderId: "",
        scenceCode: "0",
        noJson: false,
        isColor: true,
        isShow: false,
        buyEntrance: 1, //会员入口
        isActive: "0",
        animate: false,
        marqueeList: [],
        vipInfo: {
          hasMember: "", //是否是会员0否  1是
          // hasValidation: ''
          // score: ''//是否可以检测 0未检测  1已检测
          renewal: "", //是否需要续费 1是 0否
        },
        vipChoseList: [],
        timer: null,
        vipList: [], //会员信息list
        memberInfoList: [],
        enName: "", //会员英文名
        show: false,
        getType: "",
        paddingBottom: false,
        vipChoseListOne: {},
        pageShow:false,
      };
    },
    created() {
      this.checkAuditPartnerId();
      this.getType = this.$route.query.type;
      let p = localStorage.getItem("os");
      if (p == 1) {
        this.paddingBottom = false;
      } else if (p == 2) {
        this.paddingBottom = this.$route.query.paddingBottom;
      }
      console.log(this.paddingBottom);
    },
    mounted() {
      this.appVersion = localStorage.getItem("appVersion");
      // if (localStorage.getItem("token") == 'undefined' || localStorage.getItem("token") == '' || localStorage.getItem("token") == null) {
      //   //跳转到ios的登录页面
      //   this.toLogin();
      // } else {
      if (window.history && window.history.pushState) {
        //返回按钮
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", this.goBack, false);
      }
      this.getDetail();
      // }
    },
    beforeDestroy() {
      window.removeEventListener("popstate", this.goBack, false);
      clearInterval(this.timer);
      this.timer = null;
    },
    methods: {
      goBack() {
        /*if (this.vipInfo.hasMember == 0) {
          this.show = true;
        }*/
      },
      toHide() {
        this.util.toClientPath(0);
        this.show = false;
      },
      tomember() {
        this.show = false;
      },
      toDetail(item) {
        let json = {
          event_key: "h5_vip_center_products_click",
          product_id: item.id,
          product_type: item.type,
        };
        this.toCountPoint(json);
        this.toPageUrl(item.pageUrl);
      },
      toPageUrl(pageUrl) {
        console.log(pageUrl)
        window.location.href = pageUrl;
      },
      //统计埋点
      toCountPoint(json, pageUrl) {
        this.$get("/app/api/v1/newEventTrace", json)
                .then((res) => {
                  if (res.code == 200) {
                  } else {
                    this.util.toast({msg: res.message});
                  }
                })
                .catch((error) => {
                });
      },
      showMarquee: function () {
        this.animate = true;
        setTimeout(() => {
          this.marqueeList.push(this.marqueeList[0]);
          this.marqueeList.shift();
          this.animate = false;
        }, 500);
      },
      getMemberInfo() {
        let _this = this;
        let param = {
          scenceCode: this.scenceCode,
        };
        this.$get("/app/v1.0/memeber/memberTypeInfo", param)
                .then((res) => {
                  if (res.code == 200) {
                    res.data.filter(function (item, index) {
                      if (item.isRecommend == 1) {
                        _this.memberInfoList.push(item);
                      }
                    });
                    console.log(_this.memberInfoList);
                  } else {
                    this.util.toast({msg: res.message});
                  }
                })
                .catch((error) => {
                });
      },
      // 获取会员信息
      getVipInfo() {
        let _this = this;
        this.$get("/app/v1.0/memeber/memberInfo")
                .then(function (res) {
                  if (res.code == 200) {
                    if (_this.getType) {
                      //是否显示toast
                      Toast({
                        message: "该产品为会员专属产品，\n开通后即可解锁",
                        duration: 2000,
                      });
                    }
                    _this.vipInfo = res.data.memberInfo;
                    let json = {
                      event_key: "h5_vip_center_view",
                      vip_status: _this.vipInfo.hasMember,
                    };
                    _this.toCountPoint(json);
                    if (_this.vipInfo.memberTypeId == 4) {
                      //钻石
                      _this.enName = "DIAMOND MEMBER";
                      _this.vipList = [
                        {
                          vipName: "钻石会员",
                          vipType: "极速审批",
                          rate: "+60%",
                        },
                        {
                          vipName: "钻石会员",
                          vipType: "高通过率",
                          rate: "+50%",
                        },
                        {
                          vipName: "钻石会员",
                          vipType: "拒就赔保障",
                          rate: "￥100",
                        },
                        {
                          vipName: "钻石会员",
                          vipType: "新口子提醒",
                          rate: "最新动态",
                        },
                      ];
                    } else if (_this.vipInfo.memberTypeId == 3) {
                      //铂金
                      _this.enName = "PLATINUM MEMBER";
                      _this.vipList = [
                        {
                          vipName: "铂金会员",
                          vipType: "极速审批",
                          rate: "+50%",
                        },
                        {
                          vipName: "铂金会员",
                          vipType: "高通过率",
                          rate: "+40%",
                        },
                        {
                          vipName: "铂金会员",
                          vipType: "拒就赔保障",
                          rate: "￥80",
                        },
                        {
                          vipName: "铂金会员",
                          vipType: "新口子提醒",
                          rate: "最新动态",
                        },
                      ];
                    } else if (_this.vipInfo.memberTypeId == 2) {
                      //黄金
                      _this.enName = "GOLD MEMBER";
                      _this.vipList = [
                        {
                          vipName: "黄金会员",
                          vipType: "极速审批",
                          rate: "+40%",
                        },
                        {
                          vipName: "黄金会员",
                          vipType: "高通过率",
                          rate: "+30%",
                        },
                        {
                          vipName: "黄金会员",
                          vipType: "拒就赔保障",
                          rate: "￥50",
                        },
                        {
                          vipName: "黄金会员",
                          vipType: "新口子提醒",
                          rate: "最新动态",
                        },
                      ];
                    } else if (_this.vipInfo.memberTypeId == 1) {
                      //白银
                      _this.enName = "SILVER MEMBER";
                      _this.vipList = [
                        {
                          vipName: "白银会员",
                          vipType: "极速审批",
                          rate: "+30%",
                        },
                        {
                          vipName: "白银会员",
                          vipType: "高通过率",
                          rate: "+20%",
                        },
                        {
                          vipName: "白银会员",
                          vipType: "拒就赔保障",
                          rate: "￥20",
                        },
                        {
                          vipName: "白银会员",
                          vipType: "新口子提醒",
                          rate: "最新动态",
                        },
                      ];
                    }
                    // memberTypeId 1:白银，2:黄金，3:铂金，4钻石，0：免费
                    if (_this.vipInfo.hasMember) {
                      _this.util.title("我的会员");
                      // _this.getVipChose();
                      _this.getDetail();
                    } else {
                      // window.location.href = 'https://mianbaojr.cn/?m=10316';
                      _this.util.title("购买会员");
                      _this.getVipList();
                      _this.getMemberInfo();
                      setInterval(this.showMarquee, 2000);
                    }
                  } else {
                    _this.util.toast({msg: res.message});
                  }
                })
                .catch(function (error) {
                  console.log("错误");
                });
      },
      // 获取会员精选list
      getVipChose() {
        let _this = this;
        let _json = {
          page: 1,
          size: 6,
        };
        this.$get("/app/api/v1/recommend/product", _json)
                .then(function (res) {
                  if (res.code == 200) {
                    _this.vipChoseList = res.data.productList;
                  } else {
                    _this.util.toast({msg: res.message});
                  }
                })
                .catch(function (error) {
                  console.log("错误");
                });
      },
      getDetail() {
        this.$get("/app/api/v2/home/memberProductList")
                .then((res) => {
                  if (res.code == 200) {
                    this.vipChoseList = res.data;
                    this.vipChoseListOne = res.data[0];
                  } else {
                    this.util.toast({msg: res.message});
                  }
                })
                .catch((error) => {
                });
      },
      // 获取动态
      getVipList() {
        let _this = this;
        this.$get("/app/api/v1/home/headline", {})
                .then(function (res) {
                  if (res.code == 200) {
                    res.data.filter(function (item, index) {
                      if (item.type == 1) {
                        _this.marqueeList.push(item);
                      }
                    });
                  } else {
                    _this.util.toast({msg: res.message});
                  }
                })
                .catch(function (error) {
                  console.log("错误");
                });
      },
      checkPay(index, item) {
        this.isActive = index;
      },
      toShow(eventKey) {
        if (eventKey) {
          let json = {
            event_key: eventKey,
            // vip_status: this.vipInfo.hasMember,
            os: localStorage.getItem("os"),
            app_market_channel: localStorage.getItem("appMarketChannel"),
            app_version: localStorage.getItem("appVersion"),
            customer_id: localStorage.getItem("customerId"),
            udid: localStorage.getItem("udid"),
            package_name: localStorage.getItem("packageName"),
          };
          this.toCountPoint(json);
        }
        this.isShow = true;
      },
      toPage1(eventKey, buttonName) {
        let json = {
          event_key: eventKey,
          button_name: buttonName,
        };
        this.toCountPoint(json);
        // if (parseFloat(this.appVersion) >= parseFloat('1.3.0')) {
        //   //去原生卡券页面
        //   this.util.toClientPath(5);
        // } else {
        //走H5卡券页面
        this.$router.push({
          path: "/vipActive/myCard",
        });
        // }
      },
      //去登录
      toLogin() {
        try {
          window.webkit.messageHandlers.toLogin.postMessage(""); //ios
        } catch (err) {
          window.AppJs.toLogin(); //android
        }
      },
      toPage() {
        // 进入监测页面
        this.$router.push({
          path: "/vip/myBag",
        });
      },
      toCheck(eventKey, buttonName) {
        let json = {
          event_key: eventKey,
          button_name: buttonName,
        };
        this.toCountPoint(json);
        if (this.vipInfo.profession > 0) {
          //跳转到专业版
          this.$router.push({
            path: "/vip/creditCheck",
            query: {
              webRefresh: "1",
              isShowCheck: "1",
              id: 2,
            },
          });
        } else if (this.vipInfo.ordinary > 0) {
          //跳转到普通版
          this.$router.push({
            path: "/vip/creditCheck",
            query: {
              webRefresh: "1",
              isShowCheck: "1",
              id: 1,
            },
          });
        }
      },checkAuditPartnerId() {
        let _this = this;
        this.$get("/app/api/v1/user/checkAuditPartnerId")
                .then(function (res) {
                  if (res.code == 200) {
                    if(res.data){
                      _this.$router.push({
                        path: "/agree/helpCenter"
                      });
                    }else{
                      _this.pageShow=true;
                      _this.getVipInfo();
                    }
                  } else {
                    _this.pageShow=true;
                    _this.getVipInfo();
                  }
                })
                .catch(function (error) {
                  _this.pageShow=true;
                  _this.getVipInfo();
                });
      },
    },
  };
</script>
<style scoped>
  .handlevip_box {
    /* position: relative; */
    background: #fff;
    /* top: 0; */
  }

  .head_bg {
    /* background: url('../../assets/img/vip/notVip_banner.png') no-repeat top center; */
    background: url('../../assets/img/vip/new_vip_bg.png') no-repeat top center;
    background-size: 100% 100%;
    width: 100%;
    height: 3.43rem;
  }

  .btn {
    width: 100%;
    background: linear-gradient(
            132deg,
            rgb(255, 119, 46) 0%,
            rgb(255, 65, 32) 100%
    );
    box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
    border-radius: 25px;
    text-align: center;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    padding: 0.13rem 0.2rem;
    margin: 0.3rem auto;
  }

  .check_list {
    margin-top: 0.27rem;
  }

  .check_list ul {
    display: flex;
    flex: 1;
    justify-content: space-between;
    color: #999;
    font-size: 0.12rem;
  }

  .check_list .cl_title {
    color: #333;
    font-size: 0.16rem;
    margin-bottom: 0.03rem;
  }

  .vipNot_icon7_1 {
    display: inline-block;
    background: url('../../assets/img/vip/notVip_icon7_1.png') no-repeat center center;
    background-size: 100%;
    width: 0.4rem;
    height: 0.42rem;
    margin-right: 0.1rem;
    position: relative;
    top: 0.02rem;
  }

  .vipNot_icon7,
  .vipNot_icon10 {
    display: inline-block;
    background: url('../../assets/img/vip/notVip_icon7.png') no-repeat center center;
    background-size: 100%;
    width: 0.4rem;
    height: 0.42rem;
    margin-right: 0.1rem;
    position: relative;
    top: 0.02rem;
  }

  .vipNot_icon10 {
    background: url('../../assets/img/vip/notVip_icon10.png') no-repeat center center;
    background-size: 100%;
  }

  .title_bg,
  .title_bg1 {
    background: url('../../assets/img/vip/handle_title1.png') no-repeat center center;
    background-size: 100%;
    width: 1.52rem;
    height: 0.21rem;
    margin: 0 auto;
    margin-bottom: 0.15rem;
  }

  .title_bg1 {
    background: url('../../assets/img/vip/handle_title2.png') no-repeat center center;
    background-size: 100%;
  }

  .limit_bg {
    background: url('../../assets/img/vip/notVip_banner2.png') no-repeat top center;
    background-size: 100% 100%;
    width: 100%;
    height: 1.13rem;
    padding: 0.25rem 0.15rem;
    margin-top: 0.15rem;
    box-shadow: 0px 0px 10px 0px rgba(252, 120, 89, 0.15);
  }

  .special_price {
    font-size: 0.24rem;
    font-family: PingFangSC-Medium;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
    line-height: 24px;
    letter-spacing: 1px;
    text-shadow: 0px 4px 10px rgba(255, 191, 128, 0.2);
    background: linear-gradient(
            135deg,
            rgba(255, 172, 85, 1) 0%,
            rgba(255, 57, 31, 1) 100%
    );
    /* -webkit-background-clip: text; */
    -webkit-text-fill-color: transparent;
    position: relative;
    top: 0.06rem;
  }

  .rush_buy {
    font-size: 0.14rem;
    color: #e95d44;
  }

  .money {
    font-size: 0.34rem;
    font-family: DINAlternate-Bold;
    font-weight: bold;
    line-height: 34px;
    text-shadow: 0px 4px 10px rgba(255, 191, 128, 0.2);
  }

  .mo {
    background: linear-gradient(
            135deg,
            rgba(255, 172, 85, 1) 0%,
            rgba(255, 57, 31, 1) 100%
    );
    -webkit-background-clip: text;
  }

  .original_money {
    font-size: 0.12rem;
    color: #999;
  }

  .undeline {
    text-decoration: line-through;
  }

  .limit_item {
    display: flex;
    flex: 1;
  }

  .limit_item span {
    flex: 0.65;
    text-align: left;
  }

  .limit_item span:last-child {
    flex: 0.35;
    text-align: right;
  }

  .limit_item:last-child {
    margin-top: 0.05rem;
  }

  .buy_btn,
  .pay_btn {
    color: #ffffff;
    font-size: 0.17rem;
    text-align: center;
    background: linear-gradient(
            135deg,
            rgba(255, 172, 85, 1) 0%,
            rgba(255, 57, 31, 1) 100%
    );
    box-shadow: 0px 4px 10px 0px rgba(255, 191, 128, 0.2);
    border-radius: 39px;
    height: 0.5rem;
    line-height: 0.5rem;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.15rem;
  }

  .buy_btn {
    margin-top: 0.4rem;
  }

  .pay_btn {
    background: linear-gradient(
            90deg,
            rgba(122, 157, 246, 1) 0%,
            rgba(81, 117, 241, 1) 100%
    );
    box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
    border-radius: 25px;
    margin-bottom: 0.3rem;
  }
  .noVip{
    background: #1F1F36;
  }

  .noVip .con {
    /* background: #fff; */
    background: linear-gradient(
            132deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(243, 198, 152, 1) 100%
    );
    box-shadow: 0px 0px 10px 0px rgba(252, 120, 89, 0.15);
    border-radius: 6px;
    padding-bottom: 0.33rem;
  }

  .aaa {
    /* position: absolute; */
    width: 100%;
    /* top: 2.05rem; */
    padding: 0.15rem;
    margin-top: -1.7rem;
  }

  .con .con_title {
    color: #333;
    font-size: 0.14rem;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.25rem;
  }

  .con .title_left,
  .con .title_right {
    background: url('../../assets/img/vip/title_left.png') no-repeat center center;
    background-size: 100%;
    width: 0.68rem;
    height: 0.31rem;
    display: inline-block;
    position: relative;
    top: 0.12rem;
  }

  .con .title_right {
    background: url('../../assets/img/vip/title_right.png') no-repeat center center;
    background-size: 100%;
  }

  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.4;
    z-index: 11;
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    z-index: 111;
    width: 100%;
  }

  .footer .title {
    color: #c6a47e;
    font-size: 0.2rem;
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    padding: 0.1rem;
    margin-bottom: 0.15rem;
  }

  .footer .pay_way {
    margin-left: 0.05rem;
    font-size: 0.16rem;
    color: #333333;
    font-weight: bold;
  }

  .pay_way .line {
    width: 0.03rem;
    height: 0.12rem;
    background: #5175f1;
    display: inline-block;
    margin-right: 0.1rem;
  }

  .footer .remark {
    color: #c6a47e;
    font-size: 0.12rem;
    margin-bottom: 0.3rem;
  }

  .pd {
    padding: 0 0.15rem;
  }

  .footer .item {
    border-bottom: 1px solid #eee;
    margin-bottom: 0.15rem;
    margin-top: 0.15rem;
    padding-bottom: 0.15rem;
    display: flex;
    flex: 1;
    position: relative;
  }

  .footer .icon_wx,
  .footer .icon_alp {
    background: url('../../assets/img/vip/handle_alp_icon.png') no-repeat center center;
    background-size: 100%;
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
    margin-right: 0.1rem;
  }

  .footer .icon_wx {
    background: url('../../assets/img/vip/handle_wex_icon.png') no-repeat center center;
    background-size: 100%;
  }

  .footer .ite_check,
  .footer .ite_uncheck {
    background: url('../../assets/img/vip/handle_checked.png') no-repeat center center;
    background-size: 100%;
    width: 0.16rem;
    height: 0.16rem;
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0.2rem;
  }

  .footer .ite_uncheck {
    background: url('../../assets/img/vip/handle_uncheck.png') no-repeat center center;
    background-size: 100%;
  }

  .footer .pay_title {
    color: #333333;
    font-size: 0.14rem;
    position: relative;
    top: 0.03rem;
    margin-bottom: 0.06rem;
  }

  .footer .pay_con {
    color: #999999;
    font-size: 0.12rem;
  }

  /* 是vip的样式 */
  .myvip_box {
    position: relative;
    background: #fff;
  }

  .myvip_box .head_bg {
    width: 100%;
    height: 0.52rem;
    background: #2e2e30;
  }

  .myvip_box .line_bg {
    background: #f7f7f7;
    width: 100%;
    height: 0.1rem;
  }

  .myvip_box .title {
    color: #333333;
    font-size: 0.16rem;
    margin-bottom: 0.15rem;
    margin-top: 0.1rem;
  }

  .myvip_box .line {
    background: #ff391f;
    height: 0.12rem;
    width: 0.03rem;
    display: inline-block;
    margin-right: 0.1rem;
  }

  .banner_box,
  .banner_box1 {
    width: 100%;
    background: url('../../assets/img/vip/myVip_bg_new.png') no-repeat center center;
    background-size: 100% 100%;
    padding: 0.2rem 0.12rem 0.2rem 0.15rem;
  }

  .banner_box1 {
    background: url('../../assets/img/vip/myVip_bg_new.png') no-repeat center center;
    background-size: 100% 100%;
  }

  .myvip_box .my_equity {
    width: 98%;
    padding: 0 0 0 0.1rem;
  }

  .myvip_box .vip_img {
    /* background: url("../../assets/img/vip/my_bg.png") no-repeat center center;
    background-size: 100%; */
    /* width: 100%;
    position: absolute;
    left: 0;
    top: 0.1rem; */
  }

  .myvip_box .con_box {
    padding: 0.2rem 0.15rem;
    display: flex;
  }

  .myvip_box .con {
    padding-top: 0.02rem;
    padding-left: 0.1rem;
    color: #333;
  }

  .myvip_box .fn16 {
    font-size: 0.16rem;
  }

  .myvip_box .fn14 {
    font-size: 0.14rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
  }

  .myvip_box .portrait {
    width: 0.45rem;
    height: 0.45rem;
    position: relative;
    top: 0.05rem;
  }

  .myvip_box .title_box {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #fff;
  }

  .title_box .acc_type,
  .title_box .acc_num {
    font-size: 0.26rem;
    color: #fff;
    display: inline-block;
  }

  .title_box .acc_title,
  .title_box .acc_info {
    font-size: 0.12rem;
    color: #fff;
    display: inline-block;
    position: relative;
    top: -0.08rem;
    opacity: 0.3;
  }

  .acc_num,
  .acc_info {
    float: right;
  }

  .myvip_box .equity_item,
  .ban_box {
    display: flex;
    flex: 1;
    justify-content: space-between;
    margin-top: 0.28rem;
  }

  .ban_box {
    padding: 0 0.12rem;
    margin-top: 0.1rem;
  }

  .mt {
    margin-top: 0.2rem;
  }

  .myvip_box .equity_item .item {
    flex: 1;
    font-size: 0.12rem;
    color: #333333;
    position: relative;
    text-align: center;
  }

  .equity_item .item p {
    font-size: 0.12rem;
    color: #fff;
  }

  .equity_item .equity_num {
    background: rgba(255, 255, 255, 0.8);
    display: inline-block;
    padding: 0 0.05rem;
    border-radius: 9px;
  }

  .equity_item .equity_num span {
    font-size: 0.1rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 10px;
    text-shadow: 0px 4px 10px rgba(255, 191, 128, 0.2);
    color: #ff6e38;
  }

  .equity_item .equity_num .purple {
    color: #8f3eec;
  }

  .ban_box .item {
    text-align: center;
    width: 0.75rem;
    position: relative;
    font-size: 0.12rem;
  }

  .icon1_1,
  .icon2_1,
  .icon3_1 {
    background: url('../../assets/img/vip/icon1_1.png') no-repeat center center;
    background-size: 100%;
    width: 0.36rem;
    height: 0.13rem;
    display: inline-block;
    position: absolute;
    right: 0;
  }

  .icon2_1 {
    background: url('../../assets/img/vip/icon2_1.png') no-repeat center center;
    background-size: 100%;
  }

  .icon3_1 {
    background: url('../../assets/img/vip/icon3_1.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon1,
  .notVip_icon2,
  .notVip_icon3,
  .notVip_icon4,
  .notVip_icon5,
  .notVip_icon6,
  .notVip_icon7,
  .notVip_icon8,
  .notVip_icon9 {
    background: url('../../assets/img/vip/notVip_icon1.png') no-repeat center center;
    background-size: 100%;
    width: 0.45rem;
    height: 0.46rem;
    display: inline-block;
  }

  .notVip_icon2 {
    background: url('../../assets/img/vip/notVip_icon4.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon3 {
    background: url('../../assets/img/vip/notVip_icon6.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon4 {
    background: url('../../assets/img/vip/notVip_icon4.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon5 {
    background: url('../../assets/img/vip/notVip_icon5.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon6 {
    background: url('../../assets/img/vip/notVip_icon7.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon7 {
    background: url('../../assets/img/vip/notVip_icon2.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon8 {
    background: url('../../assets/img/vip/notVip_icon3.png') no-repeat center center;
    background-size: 100%;
  }

  .notVip_icon9 {
    background: url('../../assets/img/vip/notVip_icon9.png') no-repeat center center;
    background-size: 100%;
  }

  .my_icon1,
  .my_icon2,
  .my_icon3,
  .my_icon0 {
    background: url('../../assets/img/vip/myVip_icon1.png') no-repeat center center;
    background-size: 100%;
    width: 0.26rem;
    height: 0.2rem;
    display: inline-block;
  }

  .my_icon1 {
    background: url('../../assets/img/vip/myVip_icon2.png') no-repeat center center;
    background-size: 100%;
  }

  .my_icon2 {
    background: url('../../assets/img/vip/myVip_icon3.png') no-repeat center center;
    background-size: 100%;
  }

  .my_icon3 {
    background: url('../../assets/img/vip/myVip_icon4.png') no-repeat center center;
    background-size: 100%;
  }

  .myvip_box .vip_list {
    /*margin-top: 0.15rem;*/
    background: #ffffff;
    padding: 0.05rem 0.15rem;
    padding-bottom: 0.3rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    margin: 0.1rem;
    margin-top: -0.1rem;
  }

  .myvip_box .list_box {
    display: flex;
    justify-content: space-between;
    flex: 1;
    flex-flow: row wrap;
    clear: both;
    overflow: hidden;
  }

  .myvip_box .list_box a {
    flex: 0 1 47%;
    display: inline-block;
    border-bottom: 1px solid #eee;
    margin-right: 0.03rem;
    display: flex;
    padding-bottom: 0.17rem;
    padding-top: 0.15rem;
  }

  .myvip_box .list_box a li {
    display: flex;
  }

  .myvip_box .list_box .mgl {
    margin-left: 0.03rem;
  }

  .myvip_box .list_con {
    font-size: 0.12rem;
    color: #ff0000;
    margin-left: 0.1rem;
    margin-top: 0.02rem;
    z-index: 10;
  }

  .myvip_box .list_con li {
    border: none;
    padding-bottom: 0;
    padding: 0;
  }

  .myvip_box .list_con .name {
    color: #333333;
    font-size: 0.14rem;
  }

  .myvip_box .list_con .money {
    color: #ee6c67;
    font-size: 0.16rem;
  }

  .myvip_box .mb0 {
    margin-bottom: 0;
  }

  .myvip_box .right_icon {
    background: #333;
    color: #ffffff;
    font-size: 0.1rem;
    border-radius: 8px;
    display: inline-block;
    padding: 0 0.08rem;
    position: absolute;
    top: -0.04rem;
  }

  .myvip_box .title .check_btn {
    color: #991b05;
    font-size: 0.13rem;
    font-weight: normal;
  }

  .myvip_box .check_icon {
    background: url('../../assets/img/vip/my_right.png') no-repeat center center;
    background-size: 100%;
    width: 0.06rem;
    height: 0.1rem;
    display: inline-block;
  }

  .check_box {
    position: absolute;
    right: 0.15rem;
  }

  .check_btn {
    display: inline-block;
    width: 0.72rem;
    /* height: .26rem; */
    color: #ff7b51;
    border: 1px solid #ff7b51;
    border-radius: 20px;
    text-align: center;
    line-height: 0.26rem;
    position: relative;
    top: 0.1rem;
    font-weight: normal;
  }

  .check_box .trustName {
    font-size: 0.14rem;
    color: #666;
    position: relative;
    top: -0.07rem;
  }

  .check_box .trustMin {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 0.22rem;
    color: #333;
    text-align: right;
  }

  .marquee {
    width: 100%;
    height: 50px;
    align-items: center;
    /* color: #3a3a3a; */
    /* background-color: #b3effe; */
    display: flex;
    box-sizing: border-box;
  }

  .marquee_title {
    padding: 0 20px;
    height: 30px;
    font-size: 14px;
    border-right: 1px solid #d8d8d8;
    align-items: center;
  }

  .marquee_box {
    display: block;
    position: relative;
    /* height: 30px; */
    height: 0.28rem;
    overflow: hidden;
    width: 2.41rem;
    margin: 0 auto;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.2);
    font-size: 0.12rem;
    line-height: 0.28rem;
    color: #ffffff;
    text-align: center;
  }

  .marquee_list {
    display: block;
    color: #f7f7f7;
  }

  .marquee_top {
    transition: all 0.5s;
    margin-top: -30px;
  }

  .marquee_list li {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding-left: 20px;
  }

  .marquee_list li span {
    padding: 0 2px;
  }

  .red {
    color: #ff0101;
  }

  .warn {
    width: 100%;
    height: 0.38rem;
    background: rgba(255, 169, 77, 0.2);
    padding: 0 0.15rem;
    color: #666;
    font-size: 0.12rem;
    line-height: 0.38rem;
  }

  .warn_icon {
    background: url('../../assets/img/vip/vip_warn.png') no-repeat center center;
    background-size: 100%;
    width: 0.14rem;
    height: 0.14rem;
    display: inline-block;
    position: relative;
    top: 0.02rem;
  }

  .renew_btn {
    width: 0.64rem;
    height: 0.21rem;
    line-height: 0.2rem;
    text-align: center;
    border-radius: 11px;
    border: 1px solid rgba(255, 141, 77, 1);
    color: #ff8d4d;
    font-size: 0.11rem;
    float: right;
    position: relative;
    top: 0.08rem;
  }

  .check_list .triangle_border_right {
    top: 0;
  }

  .banner_box_new {
    position: relative;
  }

  .center .product {
    position: absolute;
    left: 5%;
    bottom: 17%;
  }

  .center .product .product_name {
    font-size: 0.26rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #966D25;
    line-height: 12px;
    margin: 0.1rem 0.2rem;
  }

  .center .product .ed {
    font-size: 0.2rem;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #333333;
    line-height: 40px;
    margin: 10px 20px;
  }

  .kefu_tip {
    width: 100%;
    margin: 0.1rem auto 0.2rem;
  }

  .clear {
    clear: both;
    height: 0;
    line-height: 0;
    font-size: 0
  }

  .qy_li {
    margin-top: 0.2rem;
  }

  .qy_img {
    width: 0.36rem;
    height: 0.36rem;
    float: left;
  }

  .qy_center {
    float: left;
    margin-left: 0.08rem;
    width: 60%;
  }

  .qy_center_title {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }

  .qy_center_content {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 0.14rem;
  }

  .qy_go_scan {
    float: right;
    width: 0.64rem;
    height: 0.3rem;
    background: linear-gradient(180deg, #F0C499 0%, #ECB594 100%);
    border-radius: 15px;
    font-size: 14px;
    color: #FFF;
    text-align: center;
    line-height: 0.3rem;
    margin-top: 5px;
  }

  .bottom_kefu {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    text-align: center;
    margin-top: 0.2rem;
    padding-bottom: 0.2rem;
  }
</style>
